// import { Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useState } from 'react';
import { Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { AiFillCloseCircle } from 'react-icons/ai';
import { ImArrowRight2 } from 'react-icons/im';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Logo, SubTitle, Title } from '../../../Layout/Header/components/styles';
import { handleLocalChange } from '../../../Redux/slices/local';
// import { handleLocalChange } from '../../../Redux/slices/local';

export default function FrontNav() {
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);
  const dispatch = useDispatch();
  const local = useSelector((state) => state.local.local);

  const [showNav, setShowNav] = useState(false);

  const toggleNavShow = () => {
    setShowNav(!showNav);
  };

  return (
    <nav
      className="navbar navbar-expand-lg navbar-light bg-white"
      style={{ position: 'sticky', top: '0', zIndex: 6 }}>
      <div className="container">
        <Link className="navbar-brand d-flex align-items-center" to="/">
          <div className="logo d-flex align-items-center">
            <Logo src="/assets/images/logo.webp" alt="logo" className="me-1" />
          </div>
          <div>
            <Title>
              <FormattedMessage id="government_of_nepal" />
            </Title>
            <Title>
              <FormattedMessage id="ministry_of_federal_afairs_and_general_administration" />
            </Title>
            <SubTitle>
              <FormattedMessage id="provincial_and_local_goverment_support_program" />
            </SubTitle>
          </div>
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarCollapse"
          aria-controls="navbarCollapse"
          aria-expanded="false"
          aria-label="Toggle navigation"
          onClick={toggleNavShow}>
          <span className="navbar-toggler-icon" />
        </button>
        <div className={`${showNav ? '' : 'collapse'} navbar-collapse`} id="navbarCollapse">
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarCollapse"
            aria-controls="navbarCollapse"
            aria-expanded="false"
            aria-label="Toggle navigation"
            onClick={toggleNavShow}>
            <AiFillCloseCircle fontSize="24" />
          </button>
          <ul className="navbar-nav ms-auto">
            <li className="nav-item dropdown">
              <Link to="/about" className="nav-link" data-bs-toggle="dropdown">
                <FormattedMessage id="heading.about" />
              </Link>
            </li>
            <li className="nav-item dropdown">
              <a
                className="nav-link"
                data-bs-toggle="dropdown"
                href="https://plgsp.gov.np/resources/internal-report"
                target="_blank"
                rel="noreferrer">
                <FormattedMessage id="heading.report" />
              </a>
            </li>
            <li className="nav-item dropdown">
              <a className="nav-link" data-bs-toggle="dropdown" href="#public-events">
                <FormattedMessage id="heading.events" />
              </a>
            </li>
            <li className="nav-item dropdown">
              <a
                className="nav-link"
                href="https://kms.mofaga.gov.np"
                target="_blank"
                rel="noreferrer">
                <FormattedMessage id="heading.knowledge_module" />
              </a>
            </li>
            <li className="nav-item dropdown">
              <Link to="/support" className="nav-link" data-bs-toggle="dropdown">
                <FormattedMessage id="heading.support" />
              </Link>
            </li>
          </ul>
          {isLoggedIn ? (
            <>
              <Link
                to="/admin/"
                style={{ height: '47px', width: '142px' }}
                className="navbar-btn btn btn-sm btn-primary lift ms-auto">
                <FormattedMessage id="dashboard" /> <ImArrowRight2 />
              </Link>
              <div className="navbar">
                <ul className="navbar-nav">
                  <li className="nav-item ms-3">
                    <OverlayTrigger
                      placement="bottom"
                      delay={{ show: 150, hide: 50 }}
                      overlay={<Tooltip>Switch Language</Tooltip>}>
                      <Form.Select
                        className="icon-button language-switcher"
                        onChange={(e) => dispatch(handleLocalChange(e.target.value))}
                        defaultValue={local}>
                        <option value="en-US">En</option>
                        <option value="ne">ने</option>
                      </Form.Select>
                    </OverlayTrigger>
                  </li>
                </ul>
              </div>
            </>
          ) : (
            <>
              <Link
                className="navbar-btn btn btn-sm btn-primary lift ms-auto"
                style={{ width: '98px', height: '47px', padding: '8px 0px' }}
                to={'/signin'}>
                <FormattedMessage id="login" /> <ImArrowRight2 />
              </Link>
              <div className="navbar">
                <ul className="navbar-nav">
                  <li className="nav-item ms-3">
                    <OverlayTrigger
                      placement="bottom"
                      delay={{ show: 150, hide: 50 }}
                      overlay={<Tooltip>Switch Language</Tooltip>}>
                      <Form.Select
                        className="icon-button language-switcher"
                        onChange={(e) => dispatch(handleLocalChange(e.target.value))}
                        defaultValue={local}>
                        <option value="en-US">En</option>
                        <option value="ne">ने</option>
                      </Form.Select>
                    </OverlayTrigger>
                  </li>
                </ul>
              </div>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}
